import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

/**
 * Google OAuth callback — reads `#session_id=...` from URL fragment, exchanges
 * it with our backend for a JWT, then routes the user to the dashboard.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sid = match ? decodeURIComponent(match[1]) : "";
    if (!sid) {
      toast.error("Lien Google invalide, réessayez.");
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        localStorage.setItem("npp_token", data.token);
        await refresh();
        // Clear the hash so a refresh does not re-trigger the callback
        window.history.replaceState(null, "", "/dashboard");
        toast.success("Connecté avec Google 🌸");
        nav("/dashboard", { replace: true });
      } catch (err) {
        toast.error(err.response?.data?.detail || "Connexion Google impossible");
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="washi-bg min-h-screen flex items-center justify-center" data-testid="google-callback-page">
      <div className="text-center">
        <div className="inline-block w-10 h-10 border-4 border-[#E94A3F] border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-[#1A2A40] font-bold">Connexion en cours…</p>
      </div>
    </div>
  );
}
